import script from "./ZeusAssistantHost.vue?vue&type=script&setup=true&lang=js"
export * from "./ZeusAssistantHost.vue?vue&type=script&setup=true&lang=js"

import "./ZeusAssistantHost.vue?vue&type=style&index=0&id=4b8f12fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b8f12fc"]])

export default __exports__